import baseAPI from '@/http'

const router = 'api/outrasOportunidades'

export const outrasOportunidadesApi = {
    create: (potencial) => baseAPI.post(router, potencial),
    update: (potencial) => baseAPI.put(router, potencial),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-outra-oportunidade-por-municipio/${municipioId}`),
}
